import React from "react";
import core from "../asset/core-img.jpg";

const CoreValuesSection = () => {
  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <div className="relative">
        <div className="absolute -bottom-3 -left-3 h-full w-full bg-teal-100" aria-hidden="true" />
        <img src={core} alt="Team collaborating around a table" className="relative aspect-[4/3] w-full rounded-md object-cover shadow-xl" />
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-[.2em] text-teal-700">Built on trust</p>
        <h2 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
          Our expertise
        </h2>
        <p className="mt-5 leading-8 text-slate-600">
          With integrity as a core value, we wish to provide all our customers
          with a matchless experience in terms of service and value addition. We
          understand that creating effective web solutions for a brand requires
          us to forge strong and long terms relations with our customers.
        </p>
        <div className="mt-8 grid grid-cols-3 divide-x divide-slate-200 border-y border-slate-200 py-5">
          <div className="text-center">
            <p className="text-3xl font-semibold text-teal-700">3+</p>
            <p className="mt-1 text-xs text-slate-600 sm:text-sm">Countries served</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-semibold text-teal-700">90+</p>
            <p className="mt-1 text-xs text-slate-600 sm:text-sm">Clients served</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-semibold text-teal-700">250+</p>
            <p className="mt-1 text-xs text-slate-600 sm:text-sm">Projects completed</p>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default CoreValuesSection;
